import React, { useEffect, useState } from 'react'
import { BasicHabilitationAccordion } from '../access/HabilitationAccordion'
import { DISTRIBUTION } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import DistributionUnitAction from '../../../../../../distributionUnit/actions/DistributionUnitAction'
import DtoDistributionUnit from '../../../../../../distributionUnit/dto/DtoDistributionUnit'

const HabilitationDistribution = ({}) => {
    const dispatch = useDispatch()
    const {
        distributionUnits,
    } = useSelector(store => ({
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (distributionUnits.length === 0) {
            dispatch(DistributionUnitAction.fetchDistributionUnits())
                .then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <BasicHabilitationAccordion
            stationType={DISTRIBUTION}
            title={i18n.distributionUnit}
            stations={distributionUnits}
            isLoaded={isLoaded}
        />
    )
}

HabilitationDistribution.propTypes = {
    distributionUnits: PropTypes.arrayOf(PropTypes.instanceOf(DtoDistributionUnit)),
    fetchDistributionUnits: PropTypes.func,
}

export default HabilitationDistribution